import React, {useState} from 'react';
import s from '../FinancialReport.module.css';
import style from '../../PaperworkList/PaperworkList.module.css';
import styleTableGrid from '../../ListOfProducts/ListOfProductsTableGrid/ListOfProductsTableGrid.module.css';
import GridTableHead from '../../../Components/GridTableHead/GridTableHead';
import {useGetFinStatQuery} from '../../../redux/DepotSlice/depotReportApi';
import {RequestBalanceProdType} from '../../../types/StoreReportTypes';
import {firstDayNextMonth, monthNow} from '../../../assets/utils/dateUtils';
import StatRowEl from './rows/StatRowEl';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import AddFilterButton from '../../../Components/Buttons/AddFilterButton';
import FinancialStatFilter from '../../../Components/Filter/FinancialStatFilter';

const StatisticsTable: React.FC = () => {
	const [filterMenu, setFilterMenu] = useState<boolean>(false);
	const [filters, setFilters] = React.useState<RequestBalanceProdType>({
		from_date: monthNow(),
		to_date: firstDayNextMonth(),
	});
	const {data, isLoading} = useGetFinStatQuery(filters);
	return (
		<div className={s.finalResultTable}>
			<div className={s.filterButton}>
				<AddFilterButton
					color={'blue'}
					setFilterMenu={setFilterMenu}
					filterMenu={filterMenu}
				/>
			</div>
			<FinancialStatFilter
				active={filterMenu}
				setFilters={setFilters}
				setActive={setFilterMenu}
			/>
			<div className={styleTableGrid.tableGrid}>
				<GridTableHead 
					columns={['', 'Кількість', 'сума', 'дія']}
					gridTemplateColumns="2fr repeat(3, 1fr)"
					customClassName={styleTableGrid.tableRow}
				/>
				{isLoading ? (
					<PreLoaderComponent type={'circle'} size={'big'} />
				) : (
					data?.stats.map((stat, index) => (
						<StatRowEl stat={stat} key={stat.type + index} filters={filters} />
					))
				)}
			</div>
		</div>
	);
};

export default StatisticsTable;
